import React, {useContext, useEffect} from 'react';
import {Layout} from 'antd';
import {useUrlSearchParams} from 'use-url-search-params';
import './layout.style.less';
import {AppContentView} from '../../index';
import {LayoutType} from '../../../shared/constants/AppEnums';
import AppScrollbar from '../AppScrollbar';
import {
  useLayoutActionsContext,
  useLayoutContext,
} from '../../utility/AppContextProvider/LayoutContextProvider';
import {useSidebarActionsContext} from '../../utility/AppContextProvider/SidebarContextProvider';
import MiniSidebarToggle from './MiniSidebarToggle';
import {AuthContext} from '../../../pages/auth/context';
import AppLoader from '../AppLoader';

const AppLayout = () => {
  const {isAuthenticated, checkingSession} = useContext(AuthContext);
  const {layoutType}: any = useLayoutContext();
  const {updateNavStyle}: any = useLayoutActionsContext();
  const {updateMenuStyle, setSidebarBgImage}: any = useSidebarActionsContext();
  const [params] = useUrlSearchParams();

  useEffect(() => {
    if (layoutType === LayoutType.BOXED) {
      document.body.classList.add('boxedLayout');
      document.body.classList.remove('framedLayout');
    } else if (layoutType === LayoutType.FRAMED) {
      document.body.classList.remove('boxedLayout');
      document.body.classList.add('framedLayout');
    } else {
      document.body.classList.remove('boxedLayout');
      document.body.classList.remove('framedLayout');
    }
  }, [layoutType]);

  useEffect(() => {
    if (params.layout) updateNavStyle(params.layout);
    if (params.menuStyle) updateMenuStyle(params.menuStyle);
    if (params.sidebarImage) setSidebarBgImage(true);
  }, []);

  // Right after signing in (or on reload) the token is stored before the
  // user's roles come back; until they do, neither layout is drawn, so a
  // page never shows full width and then jumps into the header and sidebar.
  if (checkingSession) return <AppLoader />;

  return (
    <React.Fragment>
      {isAuthenticated ? (
        <MiniSidebarToggle />
      ) : (
        <Layout className='auth'>
          <AppScrollbar className='main-auth-scrollbar'>
            <AppContentView />
          </AppScrollbar>
        </Layout>
      )}
    </React.Fragment>
  );
};

export default React.memo(AppLayout);
